import { BaseButtonStyledProps } from "../types";

export const getTextDecoration = ({ appearance, renderAs, state }: BaseButtonStyledProps): string => {
    // necessary for links that render to look like buttons
    if (appearance !== "link" && state.isHover) return "none";

    // handles links that render as links
    return renderAs === "a" && !state.isDisabled && (state.isActive || state.isHover || state.isFocus)
        ? "underline"
        : "none";
};
